export { default } from "./CurtailmentObjectsTab";
